<section #appSection class="apps-section container pb-3 pb-lg-5" *ngIf="totalVariationsCount > 0">
    <div class="d-flex justify-content-between align-items-baseline">
        <p class="applications-title pb-3 pb-lg-4 mb-0">APPLICATIONS</p>
        <!-- <span class="pe-0 pe-md-3 product-sort">
            {{ displayStart }} – {{ displayEnd }} of {{ totalVariationsCount }} Products
        </span> -->
    </div>
    <div class="table-responsive">
        <table class="table apps-table" [class.no-inventory]="inventoryFlag">
            <thead>
                <tr class="apps-row apps-header-row">
                    <th class="apps-th text-xl-start text-center">Item#</th>
                    <th class="apps-th text-center text-xl-start" *ngIf="!inventoryFlag">Status</th>
                    <th class="apps-th text-start">Description</th>
                    <th class="apps-th hide-mobile">Qty</th>
                    <th class="apps-th hide-mobile" *ngIf="!promotion && isMSRP">MSRP Price</th>
                    <th class="apps-th hide-mobile">Price</th>
                    <th class="apps-th hide-mobile" *ngIf="!!promotion && !isMapPricingPromo">Your Price</th>
                    <th class="apps-th hide-mobile">Purchase Options</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="productVariations && productVariations?.length > 0">
                    <tr class="apps-row apps-product-row" *ngFor="let prod of productVariations; let i = index">
                        <td class="apps-td item-col" data-label="Item#">
                            <div class="apps-item d-flex align-items-start">
                                <div class="wrap-appliction-img  me-5">
                                    <img [src]="!!prod?.product_variation_photo?.small_image ? cdnImagePath + prod?.product_variation_photo?.small_image : commonImagePath+ 'image_not_found.webp'"
                                        [title]="prod?.sku" class="product-img apps-product-img" loading="lazy" />
                                </div>
                                <span class="item-code apps-item-code">
                                    {{ prod?.sku }}
                                </span>
                            </div>
                        </td>
                        <td class="apps-td status-col text-start" data-label="Status" *ngIf="!inventoryFlag">
                            {{ prod?.inventory_qty_on_hand > 0 ? 'In stock' : 'Out of stock' }}
                        </td>
                        <td class="apps-td desc-col text-start" data-label="Description">
                            <span class="apps-desc-text preserve-line">
                                {{ prod?.long_description }}
                            </span>
                            <div class="mobile-extra apps-mobile-extra">
                                <div class="mb-2 apps-qty-select">
                                    <select class="form-select form-select-sm apps-form-select"
                                        [id]="prod?.product_variation_key + 'qty'"
                                        [(ngModel)]="orderQuantity[prod.product_variation_key]"
                                        (change)="onQtyChange($event, prod)">
                                        <option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10]" [value]="n">{{ n }}
                                        </option>
                                    </select>
                                </div>
                                <div class="price-block apps-price-block" *ngIf="!promotion && isMSRP">
                                    <ng-container *ngIf="prod?.msrp_price > 0 && isMSRP">
                                        <s>{{ prod?.msrp_price | customCurrency }}</s>
                                    </ng-container>
                                </div>
                                <div class="price-block apps-price-block">
                                    <ng-container *ngIf="prod?.customer_price > 0">
                                        <ng-container *ngIf="promotion && !isMapPricingPromo; else originalPricetemp">
                                            <s>{{ prod?.customer_price | customCurrency }}</s>
                                        </ng-container>
                                        <ng-template #originalPricetemp>
                                            {{ prod?.customer_price | customCurrency }}
                                        </ng-template>
                                        <br />
                                        <span *ngIf="!!promotion && !isMapPricingPromo"
                                            class="new-price apps-new-price">
                                            {{ promotionalPrice[i] | customCurrency }}
                                        </span>
                                    </ng-container>
                                </div>
                                <ng-container *ngIf="prod?.customer_price > 0 && addToCartFlag[prod?.product_variation_key]">
                                    <button
                                        *ngIf="(!inventoryFlag && prod?.inventory_qty_on_hand <= 0) && addToCartButtons[prod?.product_variation_key]; else otherbuttonref"
                                        (click)="onAddToCart(prod)" [id]="prod.product_variation_key"
                                        class="btn btn-cart apps-btn">
                                        PLACE BACK ORDER
                                        <div class="dropdown">
                                            <a class="dropbtn p-0" id="myBtn">
                                                <i class="fa fa-caret-down btn"></i>
                                            </a>
                                        </div>
                                    </button>
                                    <div id="myDropdown" class="dropdown-content">
                                        <li>
                                            <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                                [id]="prod.product_variation_key">
                                                Add To Wish List
                                            </a>
                                        </li>
                                    </div>
                                    <ng-template #otherbuttonref>
                                        <button
                                            *ngIf="addToCartButtons[prod?.product_variation_key] && (prod?.inventory_qty_on_hand > 0 || inventoryFlag); else checkoutbuttonref"
                                            (click)="onAddToCart(prod)" [id]="prod.product_variation_key"
                                            class="btn btn-cart apps-btn">
                                            ADD TO CART
                                            <div class="dropdown">
                                                <a class="dropbtn p-0" id="myBtn">
                                                    <i class="fa fa-caret-down btn"></i>
                                                </a>
                                            </div>
                                        </button>
                                        <div id="myDropdown" class="dropdown-content">
                                            <li>
                                                <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                                    [id]="prod.product_variation_key">
                                                    Add To Wish List
                                                </a>
                                            </li>
                                        </div>
                                        <ng-template #checkoutbuttonref>
                                            <button [routerLink]="['/cart']" [id]="prod.product_variation_key"
                                                class="btn btn-cart apps-btn" [disabled]="disableCheckoutButton">
                                                CHECKOUT NOW
                                                <div class="dropdown">
                                                    <a class="dropbtn p-0" id="myBtn">
                                                        <i class="fa fa-caret-down btn"></i>
                                                    </a>
                                                </div>
                                            </button>
                                            <div id="myDropdown" class="dropdown-content">
                                                <li>
                                                    <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                                        [id]="prod.product_variation_key">
                                                        Add To Wish List
                                                    </a>
                                                </li>
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </td>
                        <td class="apps-td hide-mobile qty-col">
                            <select class="form-select form-select-sm apps-form-select"
                                [id]="prod?.product_variation_key + 'qty'"
                                [(ngModel)]="orderQuantity[prod.product_variation_key]"
                                (change)="onQtyChange($event, prod)">
                                <option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10]" [value]="n">{{ n }}</option>
                            </select>
                        </td>
                        <td class="apps-td hide-mobile price-col" *ngIf="!promotion && isMSRP">
                            <ng-container *ngIf="prod?.msrp_price > 0 && isMSRP">
                                <s>{{ prod?.msrp_price | customCurrency }}</s>
                            </ng-container>
                        </td>
                        <td class="apps-td hide-mobile price-col">
                            <ng-container *ngIf="prod?.customer_price > 0">
                                <ng-container *ngIf="promotion && !isMapPricingPromo; else originalPricetemp">
                                    <s>{{ prod?.customer_price | customCurrency }}</s>
                                </ng-container>
                                <ng-template #originalPricetemp>
                                    {{ prod?.customer_price | customCurrency }}
                                </ng-template>
                            </ng-container>
                        </td>
                        <td class="apps-td hide-mobile your-price-col"
                            *ngIf="!!promotion && !isMapPricingPromo && prod?.customer_price > 0">
                            {{ promotionalPrice[i] | customCurrency }}
                        </td>
                        <td class="apps-td hide-mobile action-col">
                            <div class="cust-addcart" *ngIf="prod?.customer_price > 0 && addToCartFlag[prod?.product_variation_key]">
                                <button
                                    *ngIf="(!inventoryFlag && prod?.inventory_qty_on_hand <= 0) && addToCartButtons[prod?.product_variation_key]; else otherbuttonref"
                                    (click)="onAddToCart(prod)" [id]="prod.product_variation_key"
                                    class="btn btn-cart mt-2 apps-btn btn-added-to-cart">
                                    PLACE BACK ORDER
                                    <div class="dropdown">
                                        <a class="dropbtn p-0" id="myBtn">
                                            <i class="fa fa-caret-down btn btn-add-tocart"></i>
                                        </a>
                                    </div>
                                </button>
                                <div id="myDropdown" class="dropdown-content">
                                    <li>
                                        <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                            [id]="prod.product_variation_key">
                                            Add To Wish List
                                        </a>
                                    </li>
                                </div>
                                <ng-template #otherbuttonref>
                                    <button
                                        *ngIf="addToCartButtons[prod?.product_variation_key] && (prod?.inventory_qty_on_hand > 0 || inventoryFlag); else checkoutbuttonref"
                                        (click)="onAddToCart(prod)" [id]="prod.product_variation_key"
                                        class="btn btn-cart mt-2 apps-btn">
                                        ADD TO CART
                                        <div class="dropdown">
                                            <a class="dropbtn p-0" id="myBtn">
                                                <i class="fa fa-caret-down btn btn-add-tocart"></i>
                                            </a>
                                        </div>
                                    </button>
                                    <div id="myDropdown" class="dropdown-content">
                                        <li>
                                            <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                                [id]="prod.product_variation_key">
                                                Add To Wish List
                                            </a>
                                        </li>
                                    </div>
                                    <ng-template #checkoutbuttonref>
                                        <button [routerLink]="['/cart']" [id]="prod.product_variation_key"
                                            class="btn btn-cart mt-2 apps-btn" [disabled]="disableCheckoutButton">
                                            CHECKOUT NOW
                                            <div class="dropdown">
                                                <a class="dropbtn p-0" id="myBtn">
                                                    <i class="fa fa-caret-down btn btn-add-tocart"></i>
                                                </a>
                                            </div>
                                        </button>
                                        <div id="myDropdown" class="dropdown-content">
                                            <li>
                                                <a (click)="onAddToWishList(prod)" class="add_to_wishlist cursor-pointer"
                                                    [id]="prod.product_variation_key">
                                                    Add To Wish List
                                                </a>
                                            </li>
                                        </div>
                                    </ng-template>
                                </ng-template>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
    <!-- <div class="pe-3 product-sort text-end pt-3 pt-lg-5">
        {{ displayStart }} – {{ displayEnd }} of {{ totalVariationsCount }} Products
    </div> -->
    <div class="px-4 border-bottom border-top py-2 mt-3" *ngIf="totalVariationsCount > limit">
        <div class="row align-items-center justify-content-center">
            <!-- Pagination -->
            <div class="col-12">
                <div class="filter-pagination">
                    <ul class="pagination pagination-sm mb-0 d-flex justify-content-center">
                        <!-- Previous button -->
                        <li class="page-item cursor-pointer" *ngIf="currentPage > 1">
                            <a class="page-link border-0" (click)="changePage(currentPage - 1)">
                                <i class="fa-solid fa-chevron-left"></i>
                            </a>
                        </li>
                        <!-- Dynamic pages -->
                        <li class="page-item cursor-pointer" *ngFor="let page of totalPagesArray"
                            [class.active]="page === currentPage">
                            <ng-container *ngIf="page !== -1">
                                <a class="page-link cursor-pointer" (click)="changePage(page)">{{ page }}</a>
                            </ng-container>
                            <ng-container *ngIf="page === -1">
                                <span class="page">. . .</span>
                            </ng-container>
                        </li>
                        <!-- Next button -->
                        <li class="page-item cursor-pointer" *ngIf="currentPage < totalPages">
                            <a class="page-link border-0" (click)="changePage(currentPage + 1)">
                                <i class="fa-solid fa-chevron-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>